import { platformService } from '@monthio/react-components'
import developmentCloudConfig from './development-cloud'
import devConfig from './development'
import testConfig from './test'
import productionConfig from './production'
export type AppConfiguration = ReturnType<typeof getConfiguration>

const routeCodes = {
	eskat: `/eskat`,
	pension: '/pension',
	flowSplash: `/flow-splash`,
	clientConsent: `/client-consent`,
	debtOverview: `/debt-overview`,
	assetOverview: '/asset-overview',
	assetExpenses: '/asset-expenses',
	bankLoginRedirect: `/redirect-receiver`,
	incompleteParringApplicantWarning: `/incompleteParringApplicantWarningPage`,
	bankSelectionPage: `/banks`,
	bankTransactionFetchingPage: '/banks/bank-session-overview',
	consumerInputs: `/consumer-inputs`,
	miniBudget: `/minibudget`,
	flowCompleted: `/flow-completed`,
	budgetCreator: `/budget-creator`,
	flowDeleted: '/flow-deleted',
	bankAddedSuccessfully: '/bank-added-successfully',
	incomeVerification: '/income-verification',
	budgetConsumerEmail: '/budget-consumer-email',
	budgetConsumerEmailSent: '/budget-consumer-email/email-sent',
	budgetHelperQuestionnaireCivilStatus:
		'/budget-helper/questionnaire/civilStatus',
	budgetHelperQuestionnaireMergedFinances:
		'/budget-helper/questionnaire/mergedFinances',
	budgetHelperQuestionnaireSpouseConsent:
		'/budget-helper/questionnaire/spouseConsent',
	budgetHelperQuestionnaireChildrenSelector:
		'/budget-helper/questionnaire/childrenSelector',
	budgetHelperQuestionnaireChildrenAges:
		'/budget-helper/questionnaire/childrenAges',
	budgetHelperQuestionnaireBudgetFlowStart:
		'/budget-helper/questionnaire/budgetFlowStart',
	documentUpload: '/document-upload',
	samsungBrowserWarning: '/samsung-browser-warning',
	assetReplacement: '/asset-replacement',
	savingsCapacity: '/savings-capacity',
	customQuestionnaire: '/custom-questionnaire',
	assetExpensesPage: `/asset-expenses`,
	assetOverviewPage: `/asset-overview`,
} as const

const appNames = {
	transactionApp: 'TransactionClient',
	consumerApp: 'BudgetConsumerClient',
	eskatApp: 'EskatClient',
	pensionApp: 'PensionClient',
} as const

function getConfiguration() {
	const initialLanguageDetected = localStorage?.getItem('i18nextLng') !== null

	platformService.initialize()
	const environment = platformService.getEnvironment()

	const configMap: Record<string, any> = {
		'development-cloud': developmentCloudConfig,
		development: devConfig,
		test: testConfig,
		production: productionConfig,
	}

	const config = configMap[environment]

	const env = (typeof process !== 'undefined' ? process.env : {}) as Record<
		string,
		string
	>

	const hasSentryAuthToken = !!env.SENTRY_AUTH_TOKEN
	const hasSentryReleaseCommit = !!env.SENTRY_RELEASE_COMMIT
	const isSentryEnabled = hasSentryAuthToken && hasSentryReleaseCommit
	const eskatApiUrl =
		config.eskatApiUrl ?? platformService.getAppUrl('eskatCoreApp') + '/api'

	return {
		isProduction: environment === 'production',
		isTest: environment === 'test',
		isDevelopment: environment !== 'production' && environment !== 'test',
		isSentryEnabled,
		sentryDsn: config.sentryDsn,
		environment,
		sentryTracingDomains: config.sentryTracingDomains as string[],
		appNames: appNames,
		routeCodes: routeCodes,
		initialLanguageDetected,
		openReplayProject: config.openReplayProject,
		eskatApiUrl,
		pensionInfoWindowUrl:
			config.pensionInfoWindowUrl?.replace(
				'{namespace}',
				platformService.getNamespace(),
			) ?? (null as string | null),
	}
}

const configuration = getConfiguration()
export default configuration
